import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
// icons
import CaratRight from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/CaratRight';
// styles
import { LinkStyled } from './styles';

export default () => {

  // toggle state disclaimer on/off
  const stateDisclaimerIsActive = false;

  return (
    <SectionContainer
      id='additional-resources'
      disableBottomPadding>
      <Row align='center'>
        <Col medium={8}>
          <Typography
            component='h2'
            align='center'
            nextElement='typography'>
            Additional resources
          </Typography>
          <LinkStyled
            id='annuities-prospectus-and-reports-va-ann-annual-link'
            variant='primaryDeemphasize'
            linkUrl='/annuities/'
            endAdornment={CaratRight}
            endAdornmentStylesReset>
            Annuities: Get an income for life
          </LinkStyled>
          <LinkStyled
            id='annuities-prospectus-and-reports-va-ann-semiannual-link'
            variant='primaryDeemphasize'
            linkUrl='/fixed-annuity-vs-variable-annuity/underlying-fund-information/'
            endAdornment={CaratRight}
            endAdornmentStylesReset>
            Underlying Fund Information
          </LinkStyled>
          <LinkStyled
            id='annuities-prospectus-and-reports-annuity-account-a-offering-circular-link'
            variant='primaryDeemphasize'
            linkUrl='/assets/pdf/financial-reports/annuities-prospectus-and-reports/quarterly-performance-update.pdf'
            isInternalPdf
            endAdornment={CaratRight}
            endAdornmentStylesReset
            disableBottomPadding={stateDisclaimerIsActive}>
            Variable Annuity Quarterly Performance Update
          </LinkStyled>
          {stateDisclaimerIsActive && (
            // toggle state disclaimer on/off with stateDisclaimerIsActive variable - DO NOT REMOVE
            <Typography
              nextElement='typography'
              variant='small'>
              (not currently approved for use in Mississippi and Oklahoma)
            </Typography>
          )}
          <LinkStyled
            id='annuities-prospectus-and-reports-annuity-account-c-offering-circular-link'
            variant='primaryDeemphasize'
            linkUrl='/fixed-annuity-vs-variable-annuity/performance-history/'
            endAdornment={CaratRight}
            endAdornmentStylesReset>
            Variable Annuity Performance History
          </LinkStyled>
          <LinkStyled
            id='annuities-prospectus-and-reports-annuity-account-c-offering-circular-link'
            variant='primaryDeemphasize'
            linkUrl='/annuities/daily-unit-values/'
            endAdornment={CaratRight}
            endAdornmentStylesReset>
            Variable Annuity Daily Unit Values
          </LinkStyled>
        </Col>
      </Row>
    </SectionContainer>
  );
};
